var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalValue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3603 13.2856C11.2857 13.2038 11.1912 13.1426 11.0935 13.0916C10.8809 12.9807 10.6484 12.9135 10.4175 12.8528V14.6419C10.7922 14.5995 11.2225 14.4635 11.4192 14.1136C11.5132 13.9465 11.5318 13.7412 11.4936 13.5552C11.4728 13.4544 11.43 13.3618 11.3603 13.2856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4175 14.1171C11.4182 14.1158 11.4187 14.115 11.4195 14.1136C11.4188 14.1148 11.4181 14.1159 11.4175 14.1171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65991 10.4255C8.59549 10.5196 8.55506 10.6265 8.54391 10.7401C8.53275 10.8539 8.53901 10.9806 8.58226 11.0877C8.62344 11.1898 8.7097 11.2652 8.79874 11.3259C8.89865 11.3939 9.00854 11.447 9.12045 11.492C9.21434 11.5298 9.31994 11.5659 9.43378 11.6008V9.98193C9.14619 10.0433 8.83197 10.1743 8.65991 10.4255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4268 14.1003C11.4245 14.1045 11.4219 14.1089 11.4194 14.1135C11.4224 14.1082 11.4247 14.1042 11.4268 14.1003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.436 14.0839C11.4368 14.0824 11.437 14.0823 11.436 14.0839V14.0839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0479 4.35168C12.5693 3.07359 13.5859 0.194259 12.9603 0.068324C12.129 -0.0990721 10.3238 0.634939 9.45133 0.764263C8.21382 0.913681 6.86599 -0.577683 6.10944 0.253603C5.4943 0.929494 6.55045 3.38749 8.20281 4.45832C3.27307 6.88121 -3.65601 19.0443 8.43213 19.9269C25.1581 21.148 16.7828 6.71273 11.0479 4.35168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4121 14.1262C11.4093 14.1314 11.4068 14.1359 11.4048 14.1393C11.4065 14.1363 11.409 14.1319 11.4121 14.1262Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalValue);
export default __webpack_public_path__ + "static/media/total_value.c9ba7e725218a9e19bfcbccb1eedee00.svg";
export { ForwardRef as ReactComponent };